import { EventEmitter, Injectable } from '@angular/core';
//import { CalendarEvent } from 'angular-calendar';
import { BehaviorSubject } from 'rxjs';
import { AttributeValueDto } from '../models/AttributeValue';
import { DocStereoTypeDto } from '../models/DocStereoTypeDto';
import { DocumentDto } from '../models/DocumentDto';
import { RoleGroupRoleProjectIds } from '../models/GroupRole';
import { GeoDataDto } from '../models/ProjectMapInfo';
import { SquirrelSessionRequest } from '../models/SquirrelSession';


@Injectable({ providedIn: 'root' })
export class DataSharingService {
  

  squirrelSessionRequest :SquirrelSessionRequest = {
    languageKey:'',
    projectGuid:'',
    projectUrl:'',
    projectUserGroups:[],
    projectPermissions:[]
  };

  groupRoleId_ProjectId: RoleGroupRoleProjectIds = {
    roleId:'', 
    projectId:''
  }

   public geodata:EventEmitter<GeoDataDto> = new EventEmitter<GeoDataDto>();
   public geodata1:EventEmitter<GeoDataDto[]> = new EventEmitter<GeoDataDto[]>();
   //public calendarevents:EventEmitter<CalendarEvent[]> = new EventEmitter<CalendarEvent[]>();
   public projecturl: EventEmitter<string> = new EventEmitter<string>();
   public projectId: EventEmitter<string> = new EventEmitter<string>();
   public activeProjectName: EventEmitter<string> = new EventEmitter<string>();
   public documentName:EventEmitter<string> = new EventEmitter<string>();
   public documentStatus:EventEmitter<string> = new EventEmitter<string>();
   public documentColor:EventEmitter<string> = new EventEmitter<string>();
   public documentState:EventEmitter<any> = new EventEmitter<any>();

   refresh = new BehaviorSubject<any|null>(null);
   refresh$ = this.refresh.asObservable();   

   private squirrelSessionRequestState = new BehaviorSubject<SquirrelSessionRequest>(this.squirrelSessionRequest);
   squirrelSessionRequestState$ = this.squirrelSessionRequestState.asObservable();

  private colorPickerState = new BehaviorSubject<string | null>(null);
   colorPickerStateChanges$ = this.colorPickerState.asObservable();

  private shareProjectIdState = new BehaviorSubject<string | null>(null);
   shareProjectIdChanges$ = this.shareProjectIdState.asObservable();

  private documentStates = new BehaviorSubject<DocumentDto | null>(null);
   documentChanges$ = this.documentStates.asObservable();

  private documentNameState = new BehaviorSubject<string | null>(null);
   documentNameChanges$ = this.documentNameState.asObservable();

  private documentStatusState = new BehaviorSubject<any | null>(null);
   documentStatusChanges$ = this.documentStatusState.asObservable();

  private documentColorState = new BehaviorSubject<any | null>(null);
   documentColorChanges$ = this.documentColorState.asObservable();
  private documentDataState = new BehaviorSubject<AttributeValueDto | null>(null);
   documentDataChanges$ = this.documentDataState.asObservable();

  private tabIdState = new BehaviorSubject<string | null>(null);
  tabIdChanges$ = this.tabIdState.asObservable();

  private docStereoTypesState = new BehaviorSubject<DocStereoTypeDto[]| null>(null);
   docStereoTypesChanges$ = this.docStereoTypesState.asObservable();

   private roleGroupRoleProjectIdsState = new BehaviorSubject<RoleGroupRoleProjectIds>(this.groupRoleId_ProjectId);
  roleGroupRoleProjectIds$ = this.roleGroupRoleProjectIdsState.asObservable();

  constructor() { }

  changeRoleGroupRoleProjectIds(roleGroupRoleProjectIds: any) {
    this.roleGroupRoleProjectIdsState.next(roleGroupRoleProjectIds);
  }

  changeColorPickerState(colorPickerState: string | null) {
    this.colorPickerState.next(colorPickerState);
  }

  changeShareProjectIdState(shareProjectIdState: string | null) {
    this.shareProjectIdState.next(shareProjectIdState);
  }

  // changeshareDbNameState(shareDbNameState: string | null) {
  //   this.shareDbNameState.next(shareDbNameState);
  // }

  changesDocumentState(documentState: DocumentDto | null) {
    localStorage.setItem('doc-id', documentState!.id );
    this.documentStates.next(documentState);
  }

  passDocumentState(documentState: any) {
    localStorage.setItem('doc-id', documentState!.id );
    this.documentState.emit(documentState);
  }

  // changePageIdState(pagedId: string) {
  //   localStorage.setItem('page-Id', pagedId);
  //   this.pageIdState.next(pagedId);
  // }

  changesDocumentNameState(documentNameState: string | null) {
    this.documentNameState.next(documentNameState);
  }

  changeDocumentStatusState(documentStatusState: any | null) {
    this.documentStatusState.next(documentStatusState);
  }

  changeDocumentColorState(documentColorState: any | null) {
    this.documentColorState.next(documentColorState);
  }

  changeDocumentDataState(documentDataState: AttributeValueDto | null) {
    this.documentDataState.next(documentDataState);
  }

  // changeControlState(controlData: ControlData | null) {
  //   this.controlState.next(controlData);
  // }

  changeTabIdState(tabIdState: string | null) {
    this.tabIdState.next(tabIdState);
  }

  changeDocStereoTypes(docStereoTypes: DocStereoTypeDto[] | null){
    this.docStereoTypesState.next(docStereoTypes);
  }

  // changeGenericDocumentData(genericDocumentData: GenericDocumentData){
    
  //   this.genericDocumentDataState.next(genericDocumentData);
  // }

  changeSquirrelSessionRequest(squirrelSessionRequest: SquirrelSessionRequest) {
    this.squirrelSessionRequestState.next(squirrelSessionRequest);
  }

  refreshGrid(data: any){
    this.refresh.next(data);
  }

  passProjectUrl(url: string) {
    this.projecturl.emit(url);
  }

  passactiveProjectId(id: string) {
    this.projectId.emit(id);
  }  

  passGeoData(geodata: GeoDataDto) {
    this.geodata.emit(geodata);
  }

  passGeoData1(geodata: GeoDataDto[]) {
    this.geodata1.emit(geodata);
  }

  passactiveProjectName(activeProjectName: string) {
    this.activeProjectName.emit(activeProjectName);
  }

  passDocumentName(documentName: string) {
    this.documentName.emit(documentName);
  }

  passDocumentStatus(documentStatus:string) {
    this.documentStatus.emit(documentStatus);
  }

  passDocumentColor(documentColor: any) {
    this.documentColor.emit(documentColor);
  }

  // passCalendarEvents(events: CalendarEvent[]) {
  //   this.calendarevents.emit(events);
  // }

  // passDocStereoTypes(docstereotypes: DocStereoTypeDto[]) {
  //   localStorage.setItem('doc-stereo-types', JSON.stringify(docstereotypes))
  //   this.docstereotypes.emit(docstereotypes);
  // }
}
